
import Vue from "vue";
import rootStore from "@/state/store";

export default Vue.extend({
	name: "order-entry-page",
	page: {
		title: "Order Entry",
		meta: [
			{
				name: "description",
				content: "Page to enter the order for the user",
			},
		],
	},
	props: {
		theme: String,
		url: String,
	},
	computed: {
		oeToolUri(): string {
			if (this.$route.params.opportunityId) {
				return this.url + "/search?opportunityId=" + this.$route.params.opportunityId;
			} else {
				return this.url;
			}
		},
		isCompliant(): boolean {
			return rootStore.getUserIsCompliant;
		},
	}
});
